<template>
  <v-container>
    <v-data-table
        :headers="headers"
        :items="this.$store.state.boatGroups"
        :items-per-page="50"
        class="elevation-1"
    ></v-data-table>
  </v-container>
</template>

<script>

export default {

  data: () => ({
    headers: [
      {text: 'Name', value: 'id'},
      {text: 'Ref', value: 'reference'},
      //  {text: 'Rank', value: 'rank'},
      {text: 'Sail numbers', value: 'sailNumbers'},
    ]
  }),
}
</script>